module.exports = App.OrderMessage = DS.Model.extend
  created_at: DS.attr 'date'
  category: DS.attr 'string'
  account: DS.belongsTo 'api_user'
  order: DS.belongsTo 'order'
  message:  DS.attr 'string'
  date: (->
    date = moment(new Date(@get('created_at'))).tz(@get('order.timezone'))
    if date.isSame(moment(), 'day')
      date.format('H:mm')
    else
      date.format('DD MMMM в H:mm')
  ).property('created_at')
